import primaryButton from '../../../../primary-button';

const primary = (params) => primaryButton.brandedSolid.background.default.primary(params);

export default primary;
